import styled from 'styled-components'
import { rem } from 'polished'
import PriceRowPriceCaption from 'LuxKit/PricePoints/PriceRowPriceCaption'
import PriceRowValueDiscount from 'LuxKit/PricePoints/Value/PriceRowValueDiscount'
import LuxPlusPriceStack from 'luxPlus/components/LuxPlusPriceStack'

const PriceBlock = styled.div`
  display: grid;
  gap: ${rem(4)};
`

interface Props {
  caption: string
  price: number
  memberPrice?: number
  saleUnit: string
  offerConfig?: App.OfferLuxPlusConfig
  discountPercent?: number
}

/** Shared price body for the compact mobile summary and the desktop card footer. */
function FlashOfferSignUpPrice({ caption, price, memberPrice, saleUnit, offerConfig, discountPercent }: Props) {
  return <PriceBlock>
    {!!discountPercent && <PriceRowValueDiscount discountPercentage={discountPercent} />}
    <PriceRowPriceCaption>{caption}</PriceRowPriceCaption>
    <LuxPlusPriceStack
      size="L"
      price={price}
      memberPrice={memberPrice}
      saleUnit={saleUnit}
      offerConfig={offerConfig}
    />
  </PriceBlock>
}

export default FlashOfferSignUpPrice
